import { render } from "./MappingTable.vue?vue&type=template&id=db15040a"
import script from "./MappingTable.vue?vue&type=script&lang=js"
export * from "./MappingTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__